module.exports = __webpack_public_path__ + "static/media/splash-screen-mockup.21fcc660.png";